import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import React, { useCallback, useMemo } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Activity } from '../../models/activity';

interface AppActivityTableRowMobileActionsProps {
  activity: Activity;
  handleEditActivity: (Activity: Activity) => void;
  handleDeleteActivity: (Activity: Activity) => void;
}

const styles = {
  iconButtonAction: {
    marginLeft: 2,
  },
  moreIcon: {
    width: '24px',
    height: '24px',
  },
  actionIcon: {
    width: '16px',
    height: '16px',
  },
  menuItemEdit: {
    paddingX: 3,
  },
  labelSpacing: {
    marginLeft: 1,
  },
};

export function AppActivityTableRowMobileActions({
  activity,
  handleEditActivity,
  handleDeleteActivity,
}: AppActivityTableRowMobileActionsProps): JSX.Element {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const isContextMenuOpen = useMemo(() => {
    return Boolean(anchorEl);
  }, [anchorEl]);

  const handleOpenContextMenu = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    },
    []
  );

  const handleCloseContextMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleEditOptionMenu = useCallback(() => {
    handleEditActivity(activity);
    setAnchorEl(null);
  }, [handleEditActivity, activity]);

  const handleDeleteOptionMenu = useCallback(() => {
    handleDeleteActivity(activity);
    setAnchorEl(null);
  }, [handleDeleteActivity, activity]);

  return (
    <Box>
      <IconButton
        onClick={handleOpenContextMenu}
        size="small"
        sx={styles.iconButtonAction}
      >
        <MoreVertIcon sx={styles.moreIcon}></MoreVertIcon>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={isContextMenuOpen}
        onClose={handleCloseContextMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => handleEditOptionMenu()}
          sx={styles.menuItemEdit}
        >
          <EditIcon sx={styles.actionIcon} />
          <Typography sx={styles.labelSpacing}>Edit</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => handleDeleteOptionMenu()}
          sx={styles.menuItemEdit}
        >
          <DeleteIcon sx={styles.actionIcon} />
          <Typography sx={styles.labelSpacing}>Delete</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
}
